export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        SAVE: async ({state}, payload) => {
            state.isSendingSAVE = true;
            payload.th.showOverlay++;
            await payload.th.$store.dispatch('SEND_POST', {
                url: '/suppliers/task',
                parameter: payload.task,
                th: payload.th,
                showSuccessMessage: true,
                getSuccessResponse: () => {
                    payload.th.taskData = {
                        brand: null,
                        requests: [],
                        searchDepth: 100,
                        region: 'all'
                    }
                    // rewrite brand form field
                    payload.th.fieldReset = false
                    payload.th.$nextTick(() => {
                        payload.th.fieldReset = true
                    })
                },
                getResponse: () => {
                    state.isSendingSAVE = false;
                    payload.th.showOverlay--;
                }
            });
        },
    }
}